import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PunekerkuesForm } from "@/components/PunekerkuesForm";

export default function KrijoProfilPage() {
  const nav = useNavigate();
  const { user, setAuthOpen } = useAuth();
  useEffect(() => { if (user === false) setAuthOpen(true); }, [user, setAuthOpen]);
  if (!user || user === false) return <div className="p-8 text-center text-slate-500">Kyçu për të krijuar profilin.</div>;
  return <PunekerkuesForm onDone={(id) => nav(`/punekerkues/${id}`)} />;
}
